module.exports = __webpack_public_path__ + "static/media/galway-19.24e7bede.jpg";